import { Box } from '@mui/material'
import { brandColors, brandFonts } from '../../styled/brand'
import { CrosshairIcon } from './LogoMark'

/**
 * The uppercase eyebrow label that sits above headlines. Two flavors:
 * plain text (hero, legal pages) or prefixed with the crosshair mark
 * (feature sections). `color` controls both text and icon.
 */
const Kicker = ({
  children,
  icon = false,
  color = brandColors.coralText,
  align = 'left',
}: {
  children: React.ReactNode
  icon?: boolean
  color?: string
  align?: 'left' | 'center'
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: align === 'center' ? 'center' : 'flex-start',
      gap: '12px',
      color,
    }}
  >
    {icon && <CrosshairIcon size={26} />}
    <Box
      component="span"
      sx={{
        fontFamily: brandFonts.heading,
        fontWeight: 600,
        fontSize: '15px',
        letterSpacing: '0.22em',
        textTransform: 'uppercase',
      }}
    >
      {children}
    </Box>
  </Box>
)

export default Kicker
